import { getImageAltWithAiIndicator } from '@pkgs/components/utils/getImageAltWithAiIndicator';
import { UserProfileIcon } from '@pkgs/components/assets/icons/small/UserProfileIcon';
import { Copy } from '@ev-tech/ui-core-components/Copy';
import { Button } from '@ev-tech/ui-core-components/Button';
import { DEFAULT_IMAGE, getUploadCareImageUrl, ImageAiType } from '@ev-tech/search-modules-api';

import { useUAExclusiveSearchResultCardContext } from './SearchResultCardProvider';
import { ViewportSize as viewportSizes } from '../../utils/mediaQueries';
import { getUploadcareImageTransformationProps } from '../../utils/getUploadcareImageTransformationProps';

import styles from './SearchResultCardContent.module.css';

export const UAExclusiveSearchResultCardImage = () => {
  const { imageComponent: ImageComponent, link, listing, translationResolver, variant } = useUAExclusiveSearchResultCardContext();
  const sourceImage = listing.uploadCareImages?.[0];
  const aspectRatio = variant === 'preview' ? '16/9' : '3/2';

  const image = sourceImage?.id
    ? getUploadCareImageUrl({ imageId: sourceImage.id, useWaterMark: false, isBlurred: true })
    : DEFAULT_IMAGE + '-/blur/200/';

  return (
    <div className={styles.uaExclusiveListingImageWrapper} data-ispreview={variant === 'preview'}>
      <div className={styles.uaExclusiveLockedInfoContainer}>
        <UserProfileIcon />
        <div className={styles.uaExclusiveLockedInfoContent}>
          <Copy
            className={styles.uaExclusiveLockedInfoTitle}
            text={translationResolver('search.listing.image.userExclusive.locked.title')}
            as="p"
            size="s"
          />
          {variant !== 'preview' && <Copy text={translationResolver('search.listing.image.userExclusive.locked.text')} as="p" size="s" />}
        </div>
        {variant !== 'preview' && (
          <Button label={translationResolver('search.listing.image.userExclusive.locked.button')} variant="secondaryAlt" size="small" />
        )}
      </div>
      <ImageComponent
        sizes={`(max-width: ${viewportSizes.TABLET_PORTRAIT}px) 100vw, (max-width: ${viewportSizes.LAPTOP}px) 50vw, 33vw`}
        src={image}
        alt={getImageAltWithAiIndicator({
          baseAlt: link.label,
          imageAiType: ImageAiType.NONE,
          t: translationResolver,
        })}
        width={360}
        height={240}
        className={styles.uaExclusiveListingImage}
        {...getUploadcareImageTransformationProps({ aspectRatio, fit: 'cover', image: sourceImage })}
      />
    </div>
  );
};
